module.exports = __webpack_public_path__ + "img/jungong-2.e007cfb0.png";